import { getWindowScrollTop, linearConversion } from "../functions.js";

export default function KodensParallaxModule(element) {

    let [minParallaxMovement, maxParallaxMovement] = element.getAttribute('data-parallax').split(',');

    minParallaxMovement = parseInt(minParallaxMovement, 10);
    maxParallaxMovement = parseInt(maxParallaxMovement, 10);

    window.addEventListener('scroll', () => {

        var doc = document.documentElement;
        var left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
        var windowScrollTop = getWindowScrollTop()
        var windowHeight = window.innerHeight;

        let elementOffsetTop = element.getBoundingClientRect().top + window.scrollY;
        var scrollStartPosition = elementOffsetTop - windowHeight;
        var scrollStopPosition = elementOffsetTop + element.clientHeight;

        var shouldDoParallax = windowScrollTop > scrollStartPosition && windowScrollTop < scrollStopPosition;

        if (!shouldDoParallax) {
            return;
        }
        
        var transformY = linearConversion(windowScrollTop, scrollStartPosition, scrollStopPosition, minParallaxMovement, maxParallaxMovement) * -1;

        element.style.transform = 'translateY(' + transformY + 'px)';

    }, {passive: true});

    return this;

}
